import { createStarPoint } from "common/components/utils";
import { DragLayerComponentProps } from "common/components/types";

const WrapComponent = (props: DragLayerComponentProps) => {
  const { scale, property } = props;

  const width = property.style.layout.width * scale;
  const height = property.style.layout.height * scale;
  const borderWidth = property.style.view.borderWidth * scale;

  const numPoints = property.style.star.numPoints;
  const innerRadius = property.style.star.innerRadius;
  const outerRadius = property.style.star.outerRadius;

  const pointsStr = createStarPoint(
    width,
    height,
    numPoints,
    innerRadius,
    outerRadius
  );

  return (
    <svg
      overflow="visible"
      preserveAspectRatio="none"
      width={width + borderWidth}
      height={height + borderWidth}
      viewBox={`${-borderWidth / 2} ${-borderWidth / 2} ${
        width + borderWidth
      } ${height + borderWidth}`}
    >
      <polygon
        paintOrder="stroke"
        points={pointsStr}
        strokeLinejoin="miter"
        strokeMiterlimit={10}
        stroke={props.property.style.view.borderColor}
        strokeWidth={props.property.style.view.borderWidth}
        fill={props.property.style.view.backgroundColor}
      />
    </svg>
  );
};

export default WrapComponent;
